import { Collapse, CardBody, Card, CardHeader, Button, CardFooter } from 'reactstrap';
import React, { useEffect, useState } from "react";
import { width } from "../../helpers";


function CardCollapse(props) {
    const [toggleQuestion, setToggleQuestion] = useState(props.isOpen ? 1 : 0)

    function handleToggle() {
        let collapse = toggleQuestion ? 0 : 1
        setToggleQuestion(collapse)

        if (props.setCollapse)
            props.setCollapse(!collapse)
    }

    // e9ecef
    return (
        <Card className='mb-2' style={{ width: width() == "mobile" ? "" : "100%", padding: "0 !important" }}>
            <div className='' style={{ backgroundColor: "#D5DBE1" }}>
                <div className="d-flex justify-content-between ml-1 mt-1 mr-1" style={{ alignItems: "right", cursor: "pointer" }} onClick={handleToggle}>
                    <h5 className='font-weight-bold'>{props.title}</h5>
                    <h5><i className={`fa ${toggleQuestion == 1 ? 'fa-arrow-up' : 'fa-arrow-down'}`} /></h5>
                </div>
            </div>
            <Collapse isOpen={toggleQuestion === 1 ? true : false} >
                <div className="form" style={{ border: "0.5px solid #D5DBE1", overflowX: "auto", height: props.maxHeigth || "300px" }}>
                    {props.chield && <props.chield />}
                </div>
                <div style={{ border: "0.5px solid #D5DBE1", height: "45px", padding: "5px" }}>
                    {props.footer && <props.footer />}
                </div>
            </Collapse>
        </Card>
    )
}

export default CardCollapse;